import React, { useEffect, useRef, useState } from 'react';
import { COUNTRY_DIAL_CODES, countryFlagSrc } from '../../utils/countryCodes';

interface CountryCodeSelectProps {
  id: string;
  value: string;
  onChange: (dial: string) => void;
}

const CountryCodeSelect: React.FC<CountryCodeSelectProps> = ({ id, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const selected = COUNTRY_DIAL_CODES.find((country) => country.dial === value) || COUNTRY_DIAL_CODES[0];

  useEffect(() => {
    const close = (event: MouseEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return (
    <div className="country-code-picker" ref={rootRef}>
      <button
        id={id}
        type="button"
        className="country-code-button"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <img src={countryFlagSrc(selected.iso)} alt="" width={24} height={18} />
        <span>{selected.name}</span>
        <strong>{selected.dial}</strong>
      </button>
      {open ? (
        <ul className="country-code-menu" role="listbox" aria-label="Country">
          {COUNTRY_DIAL_CODES.map((country) => (
            <li key={`${country.iso}-${country.dial}`}>
              <button
                type="button"
                role="option"
                aria-selected={country.dial === selected.dial}
                onClick={() => {
                  onChange(country.dial);
                  setOpen(false);
                }}
              >
                <img src={countryFlagSrc(country.iso)} alt="" width={24} height={18} />
                <span>{country.name}</span>
                <strong>{country.dial}</strong>
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default CountryCodeSelect;
